// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"827bae11","74":"0cc450cc","144":"f4533b66","154":"b3655863","394":"9434b5ca","453":"d456ce70","586":"94d87f24","682":"718b9c12"}[chunkId] + ".chunk.js";
};